import React, { useEffect, useState } from 'react'
import HeaderTitle from '../../components/HeaderTitle'
import { useSelector } from "react-redux";
import axios from 'axios';
import { Link } from 'react-router-dom';
import swal from "sweetalert";
function Cars() {

    const { token } = useSelector((state) => state.auth)

    const [cars, setCars] = useState([])

    const deleteCars = (id) => {
        swal({
            title: "Emin misiniz?",
            text: "Bu aracı silmek istediğinizden emin misiniz?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    axios.delete(`${process.env.REACT_APP_SERVICE_URL}/vehicle/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then((response) => {
                            swal("Başarılı!", "Araç başarıyla silindi!", "success")
                            getCars()
                        })
                        .catch((error) => {
                            console.error(error)
                            swal("Hata!", "Araç silinirken bir hata oluştu!", "error")
                        })
                } else {
                    swal("İşlem iptal edildi!");
                }
            });
    }

    const getCars = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/vehicle`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                setCars(response.data)
            })
            .catch((error) => {
                console.error(error)
                setCars([])
            })
    }

    const getRemoteCar = () => {
        axios.post(`${process.env.REACT_APP_SERVICE_URL}/vehicle/from-remote`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                swal('Başarılı', 'Uzak sunucudan araç bilgisi alındı.', 'success')
                getCars()
            })
            .catch((error) => {
                console.error(error)
                swal('Hata', error?.response?.data?.errorMessage, 'error')
            })

    }

    useEffect(() => {
        getCars()
    }, [])

    return (
        <div className='container-fluid'>
            <HeaderTitle title='Araçlar' description='Araçlarınızı buradan yönetebilirsiniz.' />
            <div className='row'>
                <div className='col-md'>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='d-flex flex-wrap align-items-center gap-2 mb-3'>
                                <Link to='/cars/create' className='btn btn-dark btn-app'>
                                    <i className='bi bi-plus-lg'></i>
                                    Araç ekle
                                </Link>
                                <button type="button" title="Yenile" aria-label="Listeyi yenile" className='btn btn-outline-secondary btn-app btn-app--icon' onClick={() => getCars()}>
                                    <i className='bi bi-arrow-clockwise'></i>
                                </button>
                                <button type="button" title="Uzak sunucudan araç bilgisi al" aria-label="Uzak sunucudan araç bilgisi al" className='btn btn-outline-secondary btn-app btn-app--icon' onClick={() => getRemoteCar()}>
                                    <i className='bi bi-cloud-arrow-down'></i>
                                </button>
                            </div>

                            <div className='table-responsive'>
                                <table className='table table-bordered table-hover'>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Takip Kodu</th>
                                            <th>Plaka</th>
                                            <th>İşlemler</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            cars?.map((car) => (
                                                <tr key={car.id}>
                                                    <td>{car.id}</td>
                                                    <td>{car.trackingId}</td>
                                                    <td>{car.plate}</td>
                                                    <td>
                                                        <div className='d-inline-flex flex-wrap align-items-center gap-1'>
                                                            <Link className='btn btn-outline-primary btn-app btn-app--icon' title="Haritada göster" state={car} to={`/map-tracker`}>
                                                                <i className='bi bi-geo-alt'></i>
                                                            </Link>
                                                            <Link to={`/cars/edit`} state={car} className='btn btn-outline-primary btn-app'>Düzenle</Link>
                                                            <button type="button" className='btn btn-outline-danger btn-app'
                                                                onClick={() => deleteCars(car.id)}
                                                            >Sil</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cars